import { render, staticRenderFns } from "./touchspin.vue?vue&type=template&id=1a682558&"
import script from "./touchspin.vue?vue&type=script&lang=js&"
export * from "./touchspin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports